import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { BREADCRUMB_LD } from "@/lib/ld/careers";

export const Route = createFileRoute("/_app/careers")({
  head: () =>
    buildHead({
      title: "Careers at LohaLink — Join India's Metal Marketplace",
      description:
        "Explore career opportunities at LohaLink. Join a fast-growing team digitising India's metal and scrap trade.",
      canonical: "/careers",
      jsonLd: [BREADCRUMB_LD],
    }),
  component: lazyRouteComponent(() => import("@/pages/Careers")),
});
